export default __webpack_public_path__ + "static/media/progress.03247510.svg";